import { useEffect, useMemo, useState } from "react";
import { Box } from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";

// Organization - Monthly
import MonthlyOrganizationTickets from "./pages/organization/OrganizationTickets";
import MonthlyOrganizationTicketsPerService from "./pages/organization/OrganizationTicketsPerService";
import MonthlyOrganizationServiceTimePerService from "./pages/organization/OrganizationServiceTimePerService";
import MonthlyOrganizationArrivalRatesPerHour from "./pages/organization/OrganizationArrivalRatesPerHour";
import MonthlyOrganizationArrivalRatesPerDay from "./pages/organization/OrganizationArrivalRatesPerDay";
import MonthlyOrganizationArrivalRatesPerService from "./pages/organization/OrganizationArrivalRatesPerService";
import MonthlyOrganizationTicketsPerBranch from "./pages/organization/OrganizationTicketsPerBranch";
import MonthlyOrganizationWaitingTime from "./pages/organization/OrganizationWaitingTime";

// Branches - Monthly
import MonthlyBranchArrivalRatesPerHour from "./pages/branches/BranchArrivalRatesPerHour";
import MonthlyBranchArrivalRatesPerDay from "./pages/branches/BranchArrivalRatesPerDay";
import MonthlyBranchArrivalRatesPerService from "./pages/branches/BranchArrivalRatesPerService";
import MonthlyBranchServiceTimePerService from "./pages/branches/BranchServiceTimePerService";
import MonthlyBranchAgentServiceTimePerService from "./pages/branches/BranchAgentServiceTimePerService";
import MonthlyBranchTicketsPerService from "./pages/branches/BranchTicketsPerService";
import MonthlyBranchTicketsPerAgent from "./pages/branches/BranchTicketsPerAgent";
import MonthlyBranchAgentTicketsPerService from "./pages/branches/BranchAgentTicketsPerService";
import MonthlyBranchCustomersInBranchPerHour from "./pages/branches/BranchCustomersInBranchPerHour";
import MonthlyOrganizationWaitingTimePerService from "./pages/organization/OrganizationWaitingTimePerService";
import MonthlyBranchWaitingTimePerService from "./pages/branches/BranchWaitingTimePerService";

// Organization - Weekly
import WeeklyOrganizationTickets from "./pages/organization/OrganizationTickets";
import WeeklyOrganizationTicketsPerService from "./pages/organization/OrganizationTicketsPerService";
import WeeklyOrganizationServiceTimePerService from "./pages/organization/OrganizationServiceTimePerService";
import WeeklyOrganizationArrivalRatesPerHour from "./pages/organization/OrganizationArrivalRatesPerHour";
import WeeklyOrganizationArrivalRatesPerDay from "./pages/organization/OrganizationArrivalRatesPerDay";
import WeeklyOrganizationArrivalRatesPerService from "./pages/organization/OrganizationArrivalRatesPerService";
import WeeklyOrganizationTicketsPerBranch from "./pages/organization/OrganizationTicketsPerBranch";
import WeeklyOrganizationWaitingTime from "./pages/organization/OrganizationWaitingTime";

// Branches - Weekly
import WeeklyBranchArrivalRatesPerHour from "./pages/branches/BranchArrivalRatesPerHour";
import WeeklyBranchArrivalRatesPerDay from "./pages/branches/BranchArrivalRatesPerDay";
import WeeklyBranchArrivalRatesPerService from "./pages/branches/BranchArrivalRatesPerService";
import WeeklyBranchServiceTimePerService from "./pages/branches/BranchServiceTimePerService";
import WeeklyBranchAgentServiceTimePerService from "./pages/branches/BranchAgentServiceTimePerService";
import WeeklyBranchTicketsPerService from "./pages/branches/BranchTicketsPerService";
import WeeklyBranchTicketsPerAgent from "./pages/branches/BranchTicketsPerAgent";
import WeeklyBranchAgentTicketsPerService from "./pages/branches/BranchAgentTicketsPerService";
import WeeklyBranchCustomersInBranchPerHour from "./pages/branches/BranchCustomersInBranchPerHour";
import WeeklyOrganizationWaitingTimePerService from "./pages/organization/OrganizationWaitingTimePerService";
import WeeklyBranchWaitingTimePerService from "./pages/branches/BranchWaitingTimePerService";

// Organization - Daily
import DailyOrganizationArrivalRatesPerHour from "./pages/organization/daily/DailyOrganizationArrivalRatesPerHour";
import DailyOrganizationArrivalRatesPerService from "./pages/organization/daily/DailyOrganizationArrivalRatesPerService";
import DailyOrganizationServiceTimePerService from "./pages/organization/daily/DailyOrganizationServiceTimePerService";
import DailyOrganizationTickets from "./pages/organization/daily/DailyOrganizationTickets";
import DailyOrganizationTicketsPerBranch from "./pages/organization/daily/DailyOrganizationTicketsPerBranch";
import DailyOrganizationTicketsPerService from "./pages/organization/daily/DailyOrganizationTicketsPerService";
import DailyOrganizationWaitingTime from "./pages/organization/daily/DailyOrganizationWaitingTime";

// Branches - Daily
import DailyBranchAgentServiceTimePerService from "./pages/branches/daily/DailyBranchAgentServiceTimePerService";
import DailyBranchArrivalRatesPerService from "./pages/branches/daily/DailyBranchArrivalRatesPerService";
import DailyBranchServiceTimePerService from "./pages/branches/daily/DailyBranchServiceTimePerService";
import DailyBranchTicketsPerService from "./pages/branches/daily/DailyBranchTicketsPerService";
import DailyBranchAgentTicketsPerService from "./pages/branches/daily/DailyBranchAgentTicketsPerService";
import DailyBranchArrivalRatesPerHour from "./pages/branches/daily/DailyBranchArrivalRatesPerHour";
import DailyBranchTicketsPerAgent from "./pages/branches/daily/DailyBranchTicketsPerAgent";
import DailyBranchCustomersInBranchPerHour from "./pages/branches/daily/BranchCustomersInBranchPerHour";
import DailyOrganizationWaitingTimePerService from "./pages/organization/daily/DailyOrganizationWaitingTimePerService";
import DailyBranchWaitingTimePerService from "./pages/branches/daily/DailyBranchWaitingTimePerService";

// Annual
import AnnualDataQualityMeasurementIntegrity from "./pages/annual/AnnualDataQualityMeasurementIntegrity";
import AnnualExecutiveQueuePerformanceSummary from "./pages/annual/AnnualExecutiveQueuePerformanceSummary";
import AnnualServiceLevelWaitingTimeCompliance from "./pages/annual/AnnualServiceLevelWaitingTimeCompliance";
import AnnualWaitTimeDistributionPeakWait from "./pages/annual/AnnualWaitTimeDistributionPeakWait";
import AnnualVolumeThroughputDemandForecast from "./pages/annual/AnnualVolumeThroughputDemandForecast";
import AnnualBranchLocationPerformanceBenchmark from "./pages/annual/AnnualBranchLocationPerformanceBenchmark";
import AnnualServicePerformanceComplexity from "./pages/annual/AnnualServicePerformanceComplexity";

// Static Pages
import Cover from "./pages/Cover";
import TOC from "./pages/TOC";

// Styles
import "./assets/css/All.css";
import "./assets/css/Print.css";

// Redux
import {
  clearReports,
  getConfig,
  getLogoData,
  getMailingList,
  getReportTypes,
  getReportsData,
  setRenderConfig,
} from "./store/actions/defaultAction";
import * as defaultSelectors from "./store/selectors/defaultSelector";

// Constants - Component mapping for all report types
const COMPONENT_MAP = {
  MonthlyOrganizationTickets,
  MonthlyOrganizationTicketsPerService,
  MonthlyOrganizationServiceTimePerService,
  MonthlyOrganizationArrivalRatesPerHour,
  MonthlyOrganizationArrivalRatesPerDay,
  MonthlyOrganizationArrivalRatesPerService,
  MonthlyOrganizationTicketsPerBranch,
  MonthlyOrganizationWaitingTime,
  MonthlyBranchArrivalRatesPerHour,
  MonthlyBranchArrivalRatesPerDay,
  MonthlyBranchArrivalRatesPerService,
  MonthlyBranchServiceTimePerService,
  MonthlyBranchAgentServiceTimePerService,
  MonthlyBranchTicketsPerService,
  MonthlyBranchTicketsPerAgent,
  MonthlyBranchAgentTicketsPerService,
  MonthlyBranchCustomersInBranchPerHour,
  MonthlyOrganizationWaitingTimePerService,
  MonthlyBranchWaitingTimePerService,
  WeeklyOrganizationTickets,
  WeeklyOrganizationTicketsPerService,
  WeeklyOrganizationServiceTimePerService,
  WeeklyOrganizationArrivalRatesPerHour,
  WeeklyOrganizationArrivalRatesPerDay,
  WeeklyOrganizationArrivalRatesPerService,
  WeeklyOrganizationTicketsPerBranch,
  WeeklyOrganizationWaitingTime,
  WeeklyBranchArrivalRatesPerHour,
  WeeklyBranchArrivalRatesPerDay,
  WeeklyBranchArrivalRatesPerService,
  WeeklyBranchServiceTimePerService,
  WeeklyBranchAgentServiceTimePerService,
  WeeklyBranchTicketsPerService,
  WeeklyBranchTicketsPerAgent,
  WeeklyBranchAgentTicketsPerService,
  WeeklyBranchCustomersInBranchPerHour,
  WeeklyOrganizationWaitingTimePerService,
  WeeklyBranchWaitingTimePerService,
  DailyOrganizationArrivalRatesPerHour,
  DailyOrganizationArrivalRatesPerService,
  DailyOrganizationServiceTimePerService,
  DailyOrganizationTickets,
  DailyOrganizationTicketsPerBranch,
  DailyOrganizationTicketsPerService,
  DailyOrganizationWaitingTime,
  DailyBranchAgentServiceTimePerService,
  DailyBranchArrivalRatesPerService,
  DailyBranchServiceTimePerService,
  DailyBranchTicketsPerService,
  DailyBranchTicketsPerAgent,
  DailyBranchAgentTicketsPerService,
  DailyBranchArrivalRatesPerHour,
  DailyBranchCustomersInBranchPerHour,
  DailyOrganizationWaitingTimePerService,
  DailyBranchWaitingTimePerService,
  AnnualDataQualityMeasurementIntegrity,
  AnnualExecutiveQueuePerformanceSummary,
  AnnualServiceLevelWaitingTimeCompliance,
  AnnualWaitTimeDistributionPeakWait,
  AnnualVolumeThroughputDemandForecast,
  AnnualBranchLocationPerformanceBenchmark,
  AnnualServicePerformanceComplexity,
};

// Helper Functions
/**
 * Parse URL parameters and extract relevant values
 */
const parseURLParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const params = {};
  
  searchParams.forEach((value, key) => {
    if (key === "id") params.id = value;
    if (key === "mailingListId") params.mailingListId = value;
    if (key === "page") params.page = value;
    if (key === "renderConfig") params.renderConfig = value;
  });
  
  return params;
};

/**
 * Format report name from snake_case to PascalCase
 */
const formatReportName = (name) => {
  return name
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
};

/**
 * Determine content type based on page parameter
 */
const getContentType = (page) => {
  if (page === "cover") return "cover";
  if (page === "toc") return "toc";
  return "report";
};

const App = () => {
  const [page, setPage] = useState("");

  const dispatch = useDispatch();

  // Redux Selectors
  const { mailingList, config, logoData } = useSelector(
    (state) => state.defaultReducer
  );
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const reportTypes = useSelector(defaultSelectors.selectReportTypes);
  const reportTypeId = useSelector(defaultSelectors.selectReportTypeId);
  const data = useSelector(defaultSelectors.selectData);
  const id = useSelector(defaultSelectors.selectId);

  console.log("Reports Data:", reportsData);
  console.log("Report Types:", reportTypes);
  console.log("Report Type ID:", reportTypeId);
  console.log("Data:", data);
  console.log("ID:", id);

  console.log("======================= APP ====================");

  // Parse URL parameters on mount
  useEffect(() => {
    const params = parseURLParams();
    
    if (params.id) {
      dispatch(getReportsData(params.id));
      dispatch(getReportTypes());
    }
    
    if (params.page) setPage(params.page);
    if (params.renderConfig) {
      try {
        dispatch(setRenderConfig(JSON.parse(params.renderConfig)));
      } catch (error) {
        dispatch(setRenderConfig(null));
      }
    }
    
    if (params.mailingListId) {
      dispatch(clearReports());
      dispatch(getMailingList(params.mailingListId));
    }
  }, [dispatch]);

  // Fetch config when mailingList is available
  useEffect(() => {
    if (!_.isEmpty(mailingList) && mailingList.organizationId) {
      dispatch(getConfig(mailingList.organizationId));
    }
  }, [dispatch, mailingList]);

  // Fetch logo when config is available
  useEffect(() => {
    const logoStorageId = config?.styling?.general?.logoStorageId;
    if (logoStorageId) {
      dispatch(getLogoData(logoStorageId));
    }
  }, [config, dispatch]);

  // Compute report component - only recalculate when dependencies change
  const ReportComponent = useMemo(() => {
    if (_.isEmpty(reportsData) || _.isEmpty(reportTypes)) return null;
    
    const reportType = reportTypes.find((type) => type.id === reportTypeId);
    if (!reportType?.name) return null;
    
    const formattedName = formatReportName(reportType.name);
    console.log("formattedName", formattedName);
    
    return COMPONENT_MAP[formattedName] || null;
  }, [reportsData, reportTypes, reportTypeId]);

  // Determine content type
  const contentType = getContentType(page);
  const pageShellClassName = {
    cover: "cover-page-shell",
    toc: "toc-page-shell",
    report: "report-page-shell",
  }[contentType];

  // Render Content
  return (
    <Box className={pageShellClassName}>
      {/* Report Content */}
      {!_.isEmpty(reportsData) && contentType === "report" && (
        <Box id="reportContent" className="report-content">
          {ReportComponent && <ReportComponent showFilterForm={false} />}
        </Box>
      )}

      {/* Cover Page */}
      {mailingList && config && logoData && contentType === "cover" && (
        <Box id="coverContent">
          <Cover />
        </Box>
      )}

      {/* Table of Contents */}
      {mailingList && config && logoData && contentType === "toc" && (
        <Box id="tocContent">
          <TOC />
        </Box>
      )}

      {/* Empty State - No report selected */}
      {_.isEmpty(ReportComponent) && contentType === "report" && _.isEmpty(reportsData) && (
        <Box id="reportContent" className="report-content">
          Load One & See One
        </Box>
      )}
    </Box>
  );
};

export default App;
